import {MinusCircle, Search, UserPlus} from "react-feather";
import React, {useEffect, useRef, useState} from "react";
import {Card, CardContent} from "@mui/material";
import LoadingSpinner from "../../components/LoadingSpinner";
import Input from "../../components/input/Input";
import Dropdown from "../../components/input/Dropdown";
import SearchDropdown from "../../components/input/SearchDropdown";
import {getBulkDropdownData, getOtherRefDetails, getOtherRefSearchDropdown} from "../../api/keyvalue";
import Button from "../../components/input/Button";
import useUserCompany from "../../hooks/useUserCompany";
import {
    dedAppLevelDropdown,
    existsByDetStatusAndDetActiveAndDetDedId,
    reportSearchDeductionMaster,
    reportSearchGenerateDeductionMaster
} from "../../api/finance/deductionMasterApi";
import {dedTxnDelete, getApprovedUserData} from "../../api/finance/ApprovalProcessApi";
import {toast} from "react-toastify";
import Grid from "../../components/Grid";
import {
    ActiveCellStyle,
    ChargeCellStyle,
    DateCellRenderer, DateOnlyCellRenderer,
    ResizableScrollingTextRenderer,
    StatusCellStyle
} from "../../components/renderer/StyleRenderer";
import Modal from "../../components/Modal";
import ButtonRenderer from "../../components/renderer/ButtonRenderer";
import {MdDeleteForever} from "react-icons/md";
import {useDispatch, useSelector} from "react-redux";
import CustomAlert from "../../components/input/CustomAlert";

const DeductionReport = () => {

    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();

    const [searchClicked, setSearchClicked] = useState(false);
    const [searchSubmitLoading, setSearchSubmitLoading] = useState(false);
    const [searchRes, setSearchRes] = useState(false);
    const [isSearchLoading, setIsSearchLoading] = useState(false);

    const [searchFieldReset, setSearchFieldReset] = useState(false);
    const [activeAccordion1, setActiveAccordion1] = useState(true);
    const [resetVisible, setResetVisible] = useState(false);
    const [reportSearchClicked, setReportSearchClicked] = useState(false);
    const [reportSearchSubmitLoading, setReportSearchSubmitLoading] =
        useState(false);
    const [reportSearchRes, setReportSearchRes] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [updateNeeded, setUpdateNeeded] = useState(false);
    const [reportSearchFetchLoading, setReportSearchFetchLoading] =
        useState(false);
    // const [isLoading, setIsLoading] = useState(false);


    const [tab, setTab] = useState(1);

    const userCompany = useUserCompany();
    const [company, setCompany] = useState(
        userCompany ? userCompany.comId : null
    );
    useEffect(() => {
        setCompany(userCompany ? userCompany.comId : null);
    }, [userCompany]);

    // dropdown
    const [activeOptions, setActiveOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);
    const [itemTypeOptions, setItemTypeOptions] = useState([]);
    const [dedPeriodOptions, setDedPeriodOptions] = useState([]);
    const [paymentStatusOptions, setPaymentStatusOptions] = useState([]);
    const [approvalLevelOptions, setApprovalLevelOptions] = useState([]);

    // report

    const [reportSupplier, setReportSupplier] = useState(null);
    const [reportTransporter, setReportTransporter] = useState(null);
    const [reportVehicle, setReportVehicle] = useState(null);
    const [reportItemType, setReportItemType] = useState(null);
    const [reportItem, setReportItem] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState(null);
    const [reportStatus, setReportStatus] = useState(null);
    const [reportAppLevel, setReportAppLevel] = useState(null);
    const [reportActive, setReportActive] = useState(null);
    const [detId, setDetId] = useState(null);
    const [detCode, setDetCode] = useState(null);
    const deleteRef = useRef(null);

    //search ref
    // const fromDateRef = useRef(null);
    // const toDateRef = useRef(null);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    // report approver popup
    const [showCloseButton, setShowCloseButton] = useState(false);
    const modalRef = useRef();
    const [tableData, setTableData] = useState([]);

    const handleSearchSubmit = async (e) =>{
        if (e?.preventDefault) {
            e.preventDefault();
        }

        setActiveAccordion1(false);
        setResetVisible(true);
        setReportSearchClicked(true);
        setReportSearchSubmitLoading(true);

        const response = await reportSearchDeductionMaster({
            dedTransporter: reportTransporter,
            dedVehicle: reportVehicle,
            dedSupplier: reportSupplier,
            dedItemType: reportItemType,
            dedItem: reportItem,
            paymentStatus: paymentStatus,
            appLevels: reportAppLevel,
            status: reportStatus,
            active: reportActive,
            company: company,
            author: user.username,
            from: fromDate,
            to: toDate
        });
        console.log("search response", response);
        setReportSearchRes(response);
        setReportSearchSubmitLoading(false);
    }
    const handleSearchGenerateReport = async (e) =>{
        e.preventDefault();
        try {
            const excelBlob = await reportSearchGenerateDeductionMaster({
                dedTransporter: reportTransporter,
                dedVehicle: reportVehicle,
                dedSupplier: reportSupplier,
                dedItemType: reportItemType,
                dedItem: reportItem,
                paymentStatus: paymentStatus,
                appLevels: reportAppLevel,
                status: reportStatus,
                active: reportActive,
                company: company,
                author: user.username,
                from: fromDate,
                to: toDate
            });
            const url = window.URL.createObjectURL(new Blob([excelBlob]));

            const fileName = `REPORT OF DEDUCTION REPORT .xlsx`;

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
        } catch (err) {
            toast.error("Excel download failed");
        }
    }

    const handleSearchReset = (e) => {
        e.preventDefault();
        setReportSupplier(null);
        setReportTransporter(null);
        setReportVehicle(null);
        setReportItemType(null);
        setReportItem(null);
        setPaymentStatus(null);
        setReportStatus(null);
        setReportActive(null);
        setReportAppLevel(null);
        setSearchFieldReset(true);
        setFromDate('');
        setToDate('');
    };
    const viewApprovalList = (dedId, detId) => {
        const handleViewClick = (e) => {
            e.stopPropagation(); // Prevent event propagation

            handleDownloadPopUpChange(dedId, detId);
        };

        const handleDownloadPopUpChange = async (dedId, detId) => {
            setShowCloseButton(true);
            const response = await getApprovedUserData(dedId, detId);
            const result = response.map((item) => ({
                ...item,
                lastModifiedDate:
                    item.approvedStatus === "Approved" ? item.lastModifiedDate : null,
            }));
            setTableData(result);
            modalRef.current.showModal();
        };

        return (
            <Button
                className="ui primary button"
                style={{ display: "flex", alignItems: "center" }}
                onClick={handleViewClick}
                label="View Approved List"
            />
        );
    };

    const handleDelete = async (detId) => {
        setIsDeleting(true);
        const deletedNote = await dedTxnDelete(detId, user.username);

        if (deletedNote?.status === 200) {
            toast.success( deletedNote.data, {
                autoClose: 5000,
                containerId: "Main",
            });
            setDetId(null);
            setTimeout(() => {
                setUpdateNeeded(true);
            }, 500);
        } else {
            toast.error(deletedNote.data, {
                autoClose: 5000,
                containerId: "Main",
            });
        }
        setIsDeleting(false);
    };
    useEffect((e) => {
        if (updateNeeded) {
            handleSearchSubmit().then(r => null);
            setUpdateNeeded(false);
        }
    }, [updateNeeded]);

    const handleReset =(e)=>{
        e.preventDefault();
    }

    useEffect(() => {
        (async () => {
            // setIsLoading(true);
            setIsSearchLoading(true);

            const {
                status: statusData,
                active: activeData,
                item_type: itemType,
                deduction_period: period,
                payment_status: paymentStatus,
            } = await getBulkDropdownData([
                { key: "status" },
                { key: "active" },
                { key: "item_type" },
                { key: "deduction_period" },
                { key: "payment_status" },
            ]);
            setActiveOptions(activeData);
            setStatusOptions(statusData);
            setItemTypeOptions(itemType);
            setDedPeriodOptions(period);
            setPaymentStatusOptions(paymentStatus);

            // setIsLoading(false);
            setIsSearchLoading(false);


            const response = await dedAppLevelDropdown(company);
            setApprovalLevelOptions(response);

        })();


    }, []);
    return (
        <>
            <Modal minWidth={"600px"} ref={modalRef} closeButton={showCloseButton}>
                <>
                    <Grid
                        heading="Approval List"
                        config={[
                            {
                                headerName: "Id",
                                field: "apdId",
                                sort: "asc",
                                hide: true,
                            },
                            {
                                headerName: "Approval Name",
                                field: "approvalName",
                                cellRenderer: ResizableScrollingTextRenderer,
                            },
                            {
                                headerName: "Approver Name",
                                field: "approvedBy",
                                cellRenderer: ResizableScrollingTextRenderer,
                            },
                            {
                                headerName: "Current Status",
                                field: "approvedStatus",
                                cellRenderer: StatusCellStyle,
                            },
                            {
                                headerName: "Approved Date",
                                field: "lastModifiedDate",
                                cellRenderer: DateCellRenderer,
                            },
                        ]}
                        content={tableData}
                    />
                </>
            </Modal>
            <Card className="stakeholder-card-container">
                <CardContent>
                    <div
                        className="ui attached tabular"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <div className="ui tabular menu attached">
                            <div
                                className={`item ${tab === 1 ? "active" : ""}`}
                                onClick={() => {
                                    setTab(1);
                                }}
                            >
                                <span>
                                  <MinusCircle size={15} style={{marginRight: "5px"}}/>
                                </span>
                                Deduction Report Search
                            </div>
                        </div>
                    </div>
                    <div
                        className="ui bottom attached active tab segment"
                        style={{display: tab === 1 ? "block" : "none"}}
                    >
                        <div className="ui styled accordion" style={{width: "100%"}}>
                            <div
                                className={`title ${activeAccordion1 ? "active" : ""}`}
                                onClick={() => setActiveAccordion1(!activeAccordion1)}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <div>
                                        <span>Search</span>
                                        <Search size={14} style={{marginLeft: "10px"}}/>
                                        <i className="dropdown icon"></i>
                                    </div>

                                    <i
                                        className="refresh icon primary button"
                                        style={{
                                            display: `${resetVisible ? "flex" : "none"}`,
                                            cursor: "pointer",
                                        }}
                                        onClick={(e) => {
                                            handleReset(e);
                                        }}
                                    ></i>
                                </div>
                            </div>
                            <div className={`content ${activeAccordion1 ? "active" : ""}`}>
                                {isSearchLoading ? (
                                    <LoadingSpinner/>
                                ) : (
                                    <form className="ui form">
                                        <h4 className="ui dividing header"></h4>
                                        <div className="four fields">
                                            <Dropdown
                                                label="Item Type"
                                                placeholder="Item Type"
                                                options={itemTypeOptions}
                                                value={reportItemType}
                                                style={{height: "5px"}}
                                                onChange={(e, data) => {
                                                    setReportItemType(data.value);
                                                }}
                                            />
                                            <SearchDropdown
                                                key={1}
                                                reset={searchFieldReset}
                                                setReset={setSearchFieldReset}
                                                clearable={true}
                                                onResultSelect={(data) => setReportItem(data)}
                                                onClear={() => {
                                                    setReportItem(null);
                                                }}
                                                api={getOtherRefDetails}
                                                apiDependency={{
                                                    type: "item_type",
                                                    value: reportItemType,
                                                }}
                                                label="Item"
                                            />
                                            <SearchDropdown
                                                key={1}
                                                editMode={false}
                                                reset={searchFieldReset}
                                                setReset={setSearchFieldReset}
                                                clearable={true}
                                                onClear={() => {
                                                    setReportTransporter(null);
                                                }}
                                                onResultSelect={(data) => setReportTransporter(data)}
                                                api={getOtherRefSearchDropdown}
                                                apiDependency={{
                                                    type: "stakeholder_type",
                                                    value: "Transporter",
                                                }}
                                                label="Transporter"
                                            />
                                            <SearchDropdown
                                                key={1}
                                                editMode={false}
                                                reset={searchFieldReset}
                                                setReset={setSearchFieldReset}
                                                onResultSelect={(data) => setReportVehicle(data)}
                                                onClear={() => {
                                                    setReportVehicle(null);
                                                }}
                                                api={getOtherRefSearchDropdown}
                                                apiDependency={{
                                                    type: "vehicle",
                                                }}
                                                label="Vehicle"
                                            />
                                        </div>
                                        <div className="five fields">
                                            <SearchDropdown
                                                key={1}
                                                editMode={false}
                                                reset={searchFieldReset}
                                                setReset={setSearchFieldReset}
                                                clearable={true}
                                                onClear={() => {
                                                    setReportSupplier("");
                                                }}
                                                onResultSelect={(data) => setReportSupplier(data)}
                                                api={getOtherRefSearchDropdown}
                                                apiDependency={{
                                                    type: "stakeholder_type",
                                                    value: "Supplier",
                                                }}
                                                label="Supplier"
                                            />
                                            <Dropdown
                                                label="Payment Status"
                                                placeholder="Payment Status"
                                                options={paymentStatusOptions}
                                                style={{height: "5px"}}
                                                value={paymentStatus}
                                                onChange={(e, data) => {
                                                    setPaymentStatus(data.value);
                                                }}
                                            />
                                            <Dropdown
                                                label="Approval Level"
                                                placeholder="Approval Level"
                                                options={approvalLevelOptions}
                                                value={reportAppLevel}
                                                style={{height: "5px"}}
                                                onChange={(e, data) => {
                                                    setReportAppLevel(data.value);
                                                }}
                                            />

                                            <Dropdown
                                                label="Approval Status"
                                                placeholder="Approval Status"
                                                options={statusOptions}
                                                value={reportStatus}
                                                style={{height: "5px"}}
                                                onChange={(e, data) => {
                                                    setReportStatus(data.value);
                                                }}
                                            />
                                            <Input
                                                label="From Date"
                                                type="date"
                                                name="from_date"
                                                placeholder="From Date"
                                                // ref={fromDateRef}
                                                max={toDate ?? new Date().toISOString().split("T")[0]}
                                                value={fromDate}
                                                onChange={(e) => {
                                                    setFromDate(e.target.value);
                                                }}
                                            />
                                            <Input
                                                label="To Date"
                                                type="date"
                                                name="to_date"
                                                placeholder="To Date"
                                                // min={fromDate}
                                                max={new Date().toISOString().split("T")[0]}
                                                value={toDate}
                                                onChange={(e) => {
                                                    setToDate(e.target.value);
                                                }}
                                                // ref={toDateRef}
                                            />
                                        </div>
                                        <div
                                            style={{
                                                width: "100%",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            <div className="field" style={{width: "100%"}}>
                                                <Button
                                                    template="search"
                                                    onClick={(e) => {
                                                        handleSearchSubmit(e);
                                                    }}
                                                />
                                                <Button
                                                    template="searchReset"
                                                    onClick={(e) => {
                                                        handleSearchReset(e);
                                                    }}
                                                />
                                                <Button
                                                    template="generateReport"
                                                    onClick={(e) => {
                                                        handleSearchGenerateReport(e);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                        {reportSearchClicked && (
                            <>
                                {reportSearchSubmitLoading ? (
                                    <LoadingSpinner />
                                ) : (
                                    <Grid
                                        isLoading={reportSearchFetchLoading}
                                        heading="Deduction Report"
                                        showDownloadButton={true}
                                        downloadParam=""
                                        downloadAction="Deduction Report Download"
                                        excelSheetDownload={true}
                                        downloadOnlySelected={false}
                                        content={reportSearchRes}
                                        config={[
                                            {
                                                headerName: "Id",
                                                field: "dedId",
                                                sort: "desc",
                                                hide: true,
                                            },
                                            {
                                                headerName: "Main Deduction Code",
                                                field: "dedCode",
                                            },
                                            {
                                                headerName: "Transactional Code",
                                                field: "detdCode",
                                            },
                                            {
                                                headerName: "Item Type",
                                                field: "itemType",
                                            },
                                            {
                                                headerName: "Item",
                                                field: "itemName",
                                                cellRenderer: ResizableScrollingTextRenderer,
                                            },
                                            {
                                                headerName: "Transporter",
                                                field: "transporter",
                                                cellRenderer: ResizableScrollingTextRenderer,
                                            },
                                            {
                                                headerName: "Supplier",
                                                field: "supplier",
                                                cellRenderer: ResizableScrollingTextRenderer,
                                            },
                                            {
                                                headerName: "Vehicle",
                                                field: "vehicle",
                                                cellRenderer: ResizableScrollingTextRenderer,
                                            },
                                            {
                                                headerName: "Start Date",
                                                field: "startDate",
                                                cellRenderer: DateOnlyCellRenderer,
                                                minWidth: 250,
                                            },
                                            {
                                                headerName: "End Date",
                                                field: "endDate",
                                                cellRenderer: DateOnlyCellRenderer,
                                                minWidth: 250,
                                            },
                                            // {
                                            //     headerName: "Period Type",
                                            //     field: "periodType",
                                            // },
                                            {
                                                headerName: "Period",
                                                field: "periodType",
                                            },
                                            {
                                                headerName: "Total Amount",
                                                field: "totalPeriodAmount",
                                            },
                                            {
                                                headerName: "Installment Amount",
                                                field: "installmentValue",
                                                cellRenderer: ResizableScrollingTextRenderer,
                                            },
                                            {
                                                headerName: "Complete Period Amount",
                                                field: "completedPeriodAmount",
                                            },
                                            {
                                                headerName: "Remaining Amount To Be Recover ",
                                                field: "remainingAmountToBeRecovered",
                                            },
                                            // {
                                            //     headerName: "Payment Status",
                                            //     field: "paymentStatus",
                                            //     cellRenderer: StatusCellStyle,
                                            // },
                                            {
                                                headerName: "Deduction Status",
                                                field: "deductionStatus",
                                            },
                                            {
                                                headerName: "EV Number",
                                                field: "evNumber",
                                            },
                                            {
                                                headerName: "View Approved List",
                                                field: "viewApprovalList",
                                                cellRenderer: (params) => {
                                                    return viewApprovalList(params.data.dedId, params.data.detId);
                                                },
                                                minWidth: 250,
                                            },
                                            {
                                                headerName: "Oracle Process Status",
                                                field: "oracleProcessStatus",
                                                cellRenderer: ChargeCellStyle,
                                            },
                                            {
                                                headerName: "Transaction Delete",
                                                field: "delete",
                                                cellRenderer: ButtonRenderer,
                                                cellRendererParams: (params) => {
                                                    return {
                                                        clickHandler: async () => {
                                                            setDetId(params.data.detId);
                                                            setDetCode(params.data.detdCode);
                                                            deleteRef.current?.openAlert();
                                                        },
                                                        label: "Transaction Delete",
                                                        Icon: MdDeleteForever,
                                                        className: "ui red button",
                                                        disabled: params.data.oracleProcessStatus ? false : true
                                                    };
                                                },
                                                minWidth: 250,
                                            },
                                            {
                                                headerName: "Warranty (Months)",
                                                field: "warranty",
                                            },
                                            {
                                                headerName: "Warranty Ends",
                                                field: "warrantyEnds",
                                                cellRenderer: DateOnlyCellRenderer,
                                            },
                                            {
                                                headerName: "Job",
                                                field: "job",
                                            },
                                            {
                                                headerName: "Serial Number",
                                                field: "serialNumber",
                                            },
                                            {
                                                headerName: "Description",
                                                field: "description",
                                            },
                                            {
                                                headerName: "Reference Start Date",
                                                field: "dedReferenceStartDate",
                                                cellRenderer: DateOnlyCellRenderer,
                                                minWidth: 250,
                                            },
                                            {
                                                headerName: "Reference End Date",
                                                field: "dedReferenceEndDate",
                                                cellRenderer: DateOnlyCellRenderer,
                                                minWidth: 250,
                                            },
                                            {
                                                headerName: "Remark",
                                                field: "dedRemark",
                                            },
                                            {
                                                headerName: "Approval Level Name",
                                                field: "approvalName",
                                            },
                                            {
                                                headerName: "Approval Level",
                                                field: "approvedStatus",
                                                cellRenderer: StatusCellStyle,
                                            },
                                            {
                                                headerName: "Created By",
                                                field: "createdBy",
                                            },
                                            {
                                                headerName: "Created Date",
                                                field: "createdDate",
                                                cellRenderer: DateCellRenderer,
                                                minWidth: 250,
                                            },
                                            {
                                                headerName: "Deduction Active",
                                                field: "deductionActive",
                                                cellRenderer: ActiveCellStyle,
                                            },
                                        ]}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </CardContent>
            </Card>
            {isDeleting && (
                <div className="blur-overlay">
                    <LoadingSpinner message={`Deleting ${detCode}...`} />
                </div>
            )}
            <CustomAlert
                ref={deleteRef}
                message={`Are you sure you want to delete ${detCode}?`}
                onAccept={() => {
                    handleDelete(detId);
                }}
            />
        </>
    );
}

export default DeductionReport;
